export default {"src":"/pro/_next/static/media/eth.b2205244.svg","height":25,"width":25,"blurWidth":0,"blurHeight":0};